import * as Yup from 'yup';
import * as validationSchema from './validationSchema';

export const addLockValidationScheme = Yup.object({
  CaseId: Yup.string().required('שדה חובה'),
  MacAddress: Yup.string().required('שדה חובה'),
  PemType: Yup.number().required('שדה חובה'),
  ElectronicUnitNumber: Yup.string().required('שדה חובה'),
  FirmwareVersion: Yup.string().required('שדה חובה'),
});
